/* Spider-Verse set customizer — see sections/sv-set-customizer.liquid */
(function () {
  'use strict';

  var HERO_ORDER = ['spidey', 'miles', 'gwen'];

  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function shuffle(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }

  function SetCustomizer(root) {
    var cfgEl = root.querySelector('[data-svc-config]');
    this.root = root;
    this.cfg = JSON.parse(cfgEl.textContent);
    this.reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    this.cards = {};
    var self = this, picks = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-card]'), function (el) {
      self.cards[el.dataset.card] = el;
      picks[el.dataset.card] = [];
    });
    this.S = {
      sel: null, hero: this.firstAvailable('single', 'spidey'), partner: this.firstAvailable('pair', 'miles'),
      time: null, qty: 1, picks: picks,
      info: null, err: false, errTime: false, zoom: null, added: false, busy: false, ctaIn: true
    };
    this.bodies = {};
    this.lineIdx = {};
    this.lastPop = {};
    this.visible = true;
    this.initSkin();
    this.bind();
    this.render();
    this.startLoop();
    setTimeout(function () { self.kickAll(80); }, 350);
    this.cycle = setInterval(function () { self.cycleHero(); }, 3200);
  }

  var P = SetCustomizer.prototype;

  /* ---------- skin hooks (a skin overrides these; the defaults are the Spider-Verse behaviour) ---------- */
  P.initSkin = function () {};
  // Per-unit add-ons on top of the main variant (e.g. desk stands), in cents.
  P.addOn = function () { return 0; };
  P.addOnCompare = function () { return this.addOn(); };
  P.beforeOpen = function (id) {
    if (id === 'single') {
      var v = this.variant('single-' + this.S.hero);
      if (!v || !v.available) { this.S.hero = this.firstAvailable('single', this.S.hero); this.swapImg('single-0', this.S.hero); }
    }
    if (id === 'pair') {
      var pv = this.variant('pair-' + this.S.partner);
      if (!pv || !pv.available) { this.S.partner = this.firstAvailable('pair', this.S.partner); this.swapImg('pair-0', this.S.partner); }
    }
  };
  P.afterOpen = function (id) { if (id === 'single') this.B('single-0').sense = 1; };
  P.resetCard = function (id) {
    var s = this.S;
    if (id === 'single' && s.hero !== 'spidey') { s.hero = 'spidey'; this.swapImg('single-0', 'spidey'); this.glitch('single-0'); }
    if (id === 'pair' && s.partner !== 'miles') { s.partner = 'miles'; this.swapImg('pair-0', 'miles'); this.glitch('pair-0'); }
  };
  P.renderCardExtra = function () {};
  P.renderExtra = function () {};
  // Spring constants per body: stiffness, damping, idle sway amplitude and speed.
  P.bodyParams = function () { return { k: 26, c: 2.1, amp: 2.2, freq: 1.4 }; };
  P.kickMul = function () { return 1; };
  P.stepFx = function (dt) {
    var bs = this.bodies, self = this;
    if (bs['single-0']) {
      var sb = bs['single-0'];
      sb.sense = Math.max(sb.sense - dt * 1.4, Math.min(1, (Math.abs(sb.v) - 110) / 160));
      var se = this.q('[data-sense="single-0"]');
      if (se) se.style.opacity = Math.max(0, sb.sense).toFixed(2);
    }
    this.hit('pair-0', 'pair-1', 13, function () { self.pop('[data-heart]', 'translate(-50%, -40px) scale(1.5)', 'heart'); });
    this.hit('trio-0', 'trio-1', 8, function () { self.glitchAll(); });
    this.hit('trio-1', 'trio-2', 8, function () { self.glitchAll(); });
  };
  // Extra cart lines that ride along with the main line (e.g. stands), and extra main-line properties.
  P.addOnItems = function () { return []; };
  P.mainProps = function () { return {}; };
  // The first block of the open card still waiting for a choice (e.g. a style), or null.
  P.missingChoice = function () { return null; };
  // The hanging plushies of a card, in slot order.
  P.slots = function (id) {
    var card = this.cards[id];
    return card ? this.qa('[data-drag]', card).map(function (el) { return el.dataset.hang; }) : [];
  };

  P.q = function (sel, ctx) { return (ctx || this.root).querySelector(sel); };
  // Tolerant setter: a cached page may lack elements added in a newer version.
  P.set = function (sel, ctx, prop, val) { var el = this.q(sel, ctx); if (el) el[prop] = val; return el; };
  P.qa = function (sel, ctx) { return Array.prototype.slice.call((ctx || this.root).querySelectorAll(sel)); };
  P.money = function (cents) {
    var n = Math.round((cents || 0) / 100);
    return this.cfg.cur + n.toLocaleString('en-US');
  };
  P.variant = function (key) { return this.cfg.variants[key] || null; };
  P.firstAvailable = function (card, pref) {
    var keys = card === 'single' ? HERO_ORDER : ['miles', 'spidey'];
    var ordered = [pref].concat(keys.filter(function (k) { return k !== pref; }));
    for (var i = 0; i < ordered.length; i++) {
      var v = this.variant(card + '-' + ordered[i]);
      if (v && v.available) return ordered[i];
    }
    return pref;
  };

  /* ---------- pricing ---------- */
  P.mainVariant = function () {
    var s = this.S;
    if (s.sel === 'single') return this.variant('single-' + s.hero);
    if (s.sel === 'pair') return this.variant('pair-' + s.partner);
    if (s.sel === 'trio') return this.variant('trio');
    return null;
  };
  P.prioVariant = function () {
    if (this.S.time !== 'rush' || !this.S.sel) return null;
    return this.variant(this.S.sel === 'single' ? 'prio-single' : 'prio-bundle');
  };
  P.freeN = function (id) { return this.cfg.free[id || this.S.sel] || 0; };
  P.stickerPrice = function () { var s = this.cfg.stickers[0]; return s ? s.price : 0; };
  P.extras = function () {
    if (!this.S.sel) return [];
    return this.S.picks[this.S.sel].slice(this.freeN());
  };
  P.totals = function () {
    var s = this.S, v = this.mainVariant();
    if (!v) return null;
    var pv = this.prioVariant(), fee = pv ? pv.price : 0, N = this.freeN(), stk = this.cfg.stickers;
    var extras = this.extras(), extraSum = 0;
    extras.forEach(function (i) { extraSum += stk[i] ? stk[i].price : 0; });
    var compare = Math.max(v.compare || 0, v.price), add = this.addOn(), addC = this.addOnCompare();
    return {
      total: (v.price + add + fee) * s.qty + extraSum,
      strike: (compare + addC + N * this.stickerPrice() + fee) * s.qty + extraSum,
      save: (compare - v.price) * s.qty,
      worth: N * this.stickerPrice() * s.qty,
      freeCount: N * s.qty,
      extras: extras.length
    };
  };
  // [main line, add-ons line] e.g. ["Miles Morales + Gwen × 1", "Priority · +1 extra sticker"]
  P.summaryParts = function () {
    var s = this.S, t = this.cfg.t, n = this.cfg.names;
    if (!s.sel) return ['', ''];
    var main = s.sel === 'single' ? n[s.hero] : s.sel === 'pair' ? fill(t.pairSummary, { partner: n[s.partner] }) : t.trioSummary;
    var extra = [];
    if (s.time === 'rush') extra.push(t.sumPriority);
    var x = this.extras().length;
    if (x) extra.push(x === 1 ? t.sumExtraOne : fill(t.sumExtraMany, { n: x }));
    return [main + ' × ' + s.qty, extra.join(' · ')];
  };
  P.summaryText = function () {
    return this.summaryParts().filter(Boolean).join(' · ');
  };

  /* ---------- events ---------- */
  P.bind = function () {
    var self = this;
    Object.keys(this.cards).forEach(function (id) {
      var card = self.cards[id];
      self.q('[data-toggle]', card).addEventListener('click', function () { self.toggle(id); });
      self.qa('[data-choice]', card).forEach(function (b) {
        b.addEventListener('click', function () { id === 'single' ? self.pickHero(b.dataset.choice) : self.pickPartner(b.dataset.choice); });
      });
      self.qa('[data-time]', card).forEach(function (b) {
        b.addEventListener('click', function () { self.S.time = b.dataset.time; self.S.errTime = false; self.render(); });
      });
      self.qa('[data-info]', card).forEach(function (b) {
        b.addEventListener('click', function () { self.S.info = self.S.info === b.dataset.info ? null : b.dataset.info; self.render(); });
      });
      self.q('[data-qty-dec]', card).addEventListener('click', function () { self.S.qty = Math.max(1, self.S.qty - 1); self.render(); });
      self.q('[data-qty-inc]', card).addEventListener('click', function () { self.S.qty = Math.min(99, self.S.qty + 1); self.render(); });
      self.qa('[data-stk]', card).forEach(function (b) {
        b.addEventListener('click', function () { self.toggleSticker(id, +b.dataset.stk); });
      });
      self.qa('[data-zoom]', card).forEach(function (b) {
        b.addEventListener('click', function () { self.openZoom(+b.dataset.zoom, b); });
      });
      var auto = self.q('[data-auto]', card);
      if (auto) auto.addEventListener('click', function () { self.autoPick(id); });
      self.qa('[data-drag]', card).forEach(function (h) { self.bindDrag(h, id); });
    });

    this.q('[data-cta]').addEventListener('click', function () { self.addToCart(); });
    this.q('[data-sticky-btn]').addEventListener('click', function () { self.addToCart(); });

    // zoom modal
    var modal = this.q('[data-zoom-modal]');
    this.qa('[data-zoom-close]', modal).forEach(function (b) { b.addEventListener('click', function () { self.closeZoom(); }); });
    this.q('[data-zoom-prev]', modal).addEventListener('click', function () { self.stepZoom(-1); });
    this.q('[data-zoom-next]', modal).addEventListener('click', function () { self.stepZoom(1); });
    this.q('[data-zoom-toggle]', modal).addEventListener('click', function () {
      if (self.S.zoom != null && self.S.sel) self.toggleSticker(self.S.sel, self.S.zoom);
    });
    var stage = this.q('[data-zoom-stage]', modal), zx = null;
    stage.addEventListener('pointerdown', function (e) { if (!e.target.closest('button')) zx = e.clientX; });
    stage.addEventListener('pointerup', function (e) {
      if (zx == null) return;
      var dx = e.clientX - zx; zx = null;
      if (Math.abs(dx) > 40) self.stepZoom(dx < 0 ? 1 : -1);
    });
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.closeZoom(); return; }
      if (e.key === 'ArrowLeft') self.stepZoom(-1);
      if (e.key === 'ArrowRight') self.stepZoom(1);
      if (e.key !== 'Tab') return;
      var f = self.qa('.svc-zoom__panel button', modal);
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // sticky bar: only while the main CTA is out of view
    if ('IntersectionObserver' in window) {
      this.ctaIO = new IntersectionObserver(function (entries) {
        var inView = entries[0].isIntersecting;
        if (inView !== self.S.ctaIn) { self.S.ctaIn = inView; self.renderSticky(); }
      }, { threshold: 0.2 });
      this.ctaIO.observe(this.q('[data-cta]'));
      // pause the physics loop while the section is off screen
      this.visIO = new IntersectionObserver(function (entries) {
        self.visible = entries[0].isIntersecting;
        if (self.visible) self.startLoop(); else self.stopLoop();
      }, { rootMargin: '100px' });
      this.visIO.observe(this.root);
    }
  };

  /* ---------- state changes ---------- */
  P.toggle = function (id) {
    if (this.S.sel === id) this.closeSet(id);
    else this.openSet(id);
  };
  P.openSet = function (id) {
    var card = this.cards[id];
    if (!card || card.classList.contains('is-soldout')) return;
    var already = this.S.sel === id;
    if (!already) {
      this.S.sel = id; this.S.err = false; this.S.errTime = false; this.S.errChoice = false; this.S.info = null;
      this.beforeOpen(id);
      this.render();
    }
    this.kick(this.slots(id), 170);
    this.afterOpen(id, already);
  };
  P.closeSet = function (id) {
    var s = this.S;
    s.picks[id] = [];
    s.sel = null; s.zoom = null; s.err = false; s.errTime = false; s.errChoice = false; s.info = null; s.time = null; s.qty = 1;
    this.resetCard(id);
    this.render();
    this.kick(this.slots(id), 90);
  };
  P.pickHero = function (c) {
    this.kick(['chip-s-' + c], 180);
    if (this.S.hero === c) { this.kick(['single-0'], 120); return; }
    this.S.hero = c;
    this.swapImg('single-0', c);
    this.glitch('single-0'); this.kick(['single-0'], 150); this.B('single-0').sense = 1;
    this.bubble('single', this.line(c));
    this.render();
  };
  P.pickPartner = function (c) {
    this.kick(['chip-p-' + c], 180);
    if (this.S.partner === c) { this.kick(['pair-0'], 120); return; }
    this.S.partner = c;
    this.swapImg('pair-0', c);
    this.glitch('pair-0'); this.kick(['pair-0', 'pair-1'], 140);
    this.bubble('pair', this.line('p' + c));
    this.render();
  };
  P.cycleHero = function () {
    if (this.reduce || !this.visible || this.S.sel === 'single' || !this.cards.single) return;
    if (this.B('single-0').drag) return;
    var next = HERO_ORDER[(HERO_ORDER.indexOf(this.S.hero) + 1) % 3];
    this.S.hero = next;
    this.swapImg('single-0', next);
    this.glitch('single-0'); this.kick(['single-0'], 70);
  };
  P.toggleSticker = function (id, i) {
    var arr = this.S.picks[id], j = arr.indexOf(i);
    if (j >= 0) arr.splice(j, 1); else arr.push(i);
    this.render();
  };
  P.autoPick = function (id) {
    var arr = this.S.picks[id], need = this.freeN(id) - arr.length;
    var pool = shuffle(this.cfg.stickers.map(function (x, i) { return i; }).filter(function (i) { return arr.indexOf(i) < 0; }));
    this.S.picks[id] = arr.concat(pool.slice(0, Math.max(0, need)));
    this.S.err = false;
    this.render();
  };
  P.line = function (key) {
    var lines = this.cfg.lines[key];
    if (!lines) return '';
    lines = lines.filter(Boolean);
    if (!lines.length) return '';
    var i = this.lineIdx[key] || 0;
    this.lineIdx[key] = (i + 1) % lines.length;
    return lines[i % lines.length];
  };

  /* ---------- zoom ---------- */
  P.openZoom = function (i, opener) {
    this.zoomOpener = opener;
    this.S.zoom = i;
    this.render();
    var x = this.q('.svc-zoom__x');
    if (x) x.focus();
  };
  P.closeZoom = function () {
    if (this.S.zoom == null) return;
    this.S.zoom = null;
    this.render();
    if (this.zoomOpener) this.zoomOpener.focus();
  };
  P.stepZoom = function (d) {
    if (this.S.zoom == null) return;
    var n = this.cfg.stickers.length;
    this.S.zoom = (this.S.zoom + d + n) % n;
    this.render();
  };

  /* ---------- rendering ---------- */
  P.render = function () {
    var self = this, s = this.S, t = this.cfg.t, open = !!s.sel;
    this.root.classList.toggle('is-open', open);
    this.q('[data-guide]').textContent = open ? t.guideOpen : t.guideClosed;

    Object.keys(this.cards).forEach(function (id) { self.renderCard(id); });

    var tot = this.totals(), bundle = open && s.sel !== 'single';
    var sum = this.q('[data-summary]');
    sum.hidden = !tot;
    if (tot) {
      var parts = this.summaryParts();
      this.q('[data-sum-label]').textContent = parts[0];
      this.set('[data-sum-label2]', null, 'textContent', parts[1]);
      this.q('[data-sum-total]').textContent = this.money(tot.total);
      this.set('[data-sum-worth]', null, 'hidden', !bundle);
      this.set('[data-sum-perks]', null, 'hidden', !bundle);
      if (bundle) {
        this.q('[data-sum-strike]').textContent = this.money(tot.strike);
        this.set('[data-sum-save]', null, 'textContent', fill(t.saveLine, { save: this.money(tot.strike - tot.total), worth: this.money(tot.worth), n: tot.freeCount }));
        var gift = this.set('[data-sum-gift]', null, 'textContent', fill(t.saveGift, { n: tot.freeCount }));
        if (gift) gift.hidden = !tot.freeCount;
      }
    }
    var cta = this.q('[data-cta]');
    cta.classList.toggle('is-added', s.added);
    cta.disabled = s.busy;
    cta.textContent = s.added ? t.ctaAdded : s.busy ? t.ctaAdding : s.failed ? t.ctaError : (tot ? fill(t.ctaReady, { total: this.money(tot.total) }) : t.ctaIdle);

    this.renderZoom();
    this.renderSticky();
    this.renderExtra();
  };

  P.renderCard = function (id) {
    var s = this.S, t = this.cfg.t, card = this.cards[id], on = s.sel === id, self = this;
    card.classList.toggle('is-on', on);
    this.q('[data-toggle]', card).setAttribute('aria-expanded', on ? 'true' : 'false');
    var drawer = this.q('[data-drawer]', card);
    if (on) drawer.removeAttribute('inert'); else drawer.setAttribute('inert', '');

    this.qa('[data-choice]', card).forEach(function (b) {
      var cur = id === 'single' ? s.hero : s.partner;
      b.setAttribute('aria-pressed', b.dataset.choice === cur && on ? 'true' : 'false');
    });

    // making time
    var timeErr = on && s.errTime && !s.time;
    this.q('[data-time-box]', card).classList.toggle('is-err', timeErr);
    this.q('[data-time-req]', card).hidden = !timeErr;
    this.q('[data-time-err]', card).hidden = !timeErr;
    this.qa('[data-time]', card).forEach(function (b) { b.setAttribute('aria-pressed', on && s.time === b.dataset.time ? 'true' : 'false'); });
    this.qa('[data-info]', card).forEach(function (b) { b.setAttribute('aria-expanded', on && s.info === b.dataset.info ? 'true' : 'false'); });
    var ib = this.q('[data-info-box]', card), showInfo = on && !!s.info;
    ib.hidden = !showInfo;
    if (showInfo) {
      ib.classList.toggle('is-rush', s.info === 'rush');
      this.q('[data-info-title]', ib).textContent = this.cfg.info[s.info][0];
      this.q('[data-info-text]', ib).textContent = this.cfg.info[s.info][1];
    }
    this.q('[data-qty]', card).textContent = on ? s.qty : 1;
    this.renderCardExtra(id, card, on);

    // stickers
    var box = this.q('[data-stk-box]', card);
    if (!box) return;
    var N = this.freeN(id), mine = s.picks[id], k = mine.length, left = Math.max(0, N - k);
    var err = on && s.err && k < N, stk = this.cfg.stickers;
    box.classList.toggle('is-err', err);
    var title, sub;
    if (N === 0) { title = t.stkTitleSingle; sub = t.stkSubSingle; }
    else if (k < N) { title = fill(t.stkTitlePick, { n: N, left: left, price: this.money(this.stickerPrice()) }); sub = fill(t.stkSubPick, { n: N, left: left }); }
    else { title = fill(t.stkTitleDone, { n: N, left: left, price: this.money(this.stickerPrice()) }); sub = fill(t.stkSubDone, { n: N, left: left }); }
    this.q('[data-stk-title]', box).textContent = title;
    this.q('[data-stk-sub]', box).textContent = sub || '';
    var counter = this.q('[data-counter]', box);
    if (counter) { counter.textContent = Math.min(k, N) + '/' + N; counter.classList.toggle('is-done', k >= N); }
    this.q('[data-stk-err]', box).hidden = !err;
    this.q('[data-stk-err-text]', box).textContent = left === 1 ? t.stkErrOne : fill(t.stkErrMany, { n: left });
    var auto = this.q('[data-auto]', box);
    if (auto) { auto.hidden = !(k < N); this.q('[data-auto-text]', auto).textContent = fill(t.auto, { n: left }); }
    this.qa('[data-stk]', box).forEach(function (b) {
      var i = +b.dataset.stk, idx = mine.indexOf(i), picked = idx >= 0;
      var free = picked ? idx < N : k < N;
      b.setAttribute('aria-pressed', picked ? 'true' : 'false');
      var tag = self.q('[data-tag]', b);
      tag.textContent = free ? t.tagFree : fill(t.tagPaid, { price: self.money(stk[i].price) });
      tag.classList.toggle('is-free', free);
    });
  };

  P.renderZoom = function () {
    var s = this.S, t = this.cfg.t, modal = this.q('[data-zoom-modal]');
    var open = s.zoom != null && !!s.sel;
    modal.hidden = !open;
    if (!open) return;
    var stk = this.cfg.stickers, item = stk[s.zoom], N = this.freeN(), mine = s.picks[s.sel], k = mine.length;
    var idx = mine.indexOf(s.zoom), picked = idx >= 0, free = picked ? idx < N : k < N;
    var price = this.money(item.price);
    this.q('[data-zoom-counter]', modal).textContent = N > 0 ? fill(t.zoomCounter, { k: Math.min(k, N), n: N }) : '';
    this.q('[data-zoom-pos]', modal).textContent = (s.zoom + 1) + ' / ' + stk.length;
    var img = this.q('[data-zoom-img]', modal);
    img.src = item.img; img.alt = item.name;
    this.q('[data-zoom-name]', modal).textContent = item.name;
    var tag = this.q('[data-zoom-tag]', modal);
    tag.textContent = (free ? t.tagFree : (picked ? price : fill(t.tagPaid, { price: price }))) + (picked ? ' ✓' : '');
    tag.classList.toggle('is-free', free);
    var act = this.q('[data-zoom-toggle]', modal);
    act.textContent = picked ? t.zoomRemove : t.zoomAdd;
    act.classList.toggle('is-on', picked);
    act.setAttribute('aria-pressed', picked ? 'true' : 'false');
    this.set('[data-zoom-stamp]', modal, 'hidden', !picked);
    this.q('[data-zoom-stage]', modal).classList.toggle('is-on', picked);
  };

  P.renderSticky = function () {
    var s = this.S, t = this.cfg.t, bar = this.q('[data-sticky]');
    var show = !!s.sel && !s.ctaIn, tot = this.totals();
    bar.classList.toggle('is-shown', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    var btn = this.q('[data-sticky-btn]', bar);
    btn.tabIndex = show ? 0 : -1;
    btn.disabled = s.busy;
    btn.classList.toggle('is-added', s.added);
    btn.textContent = s.added ? t.stickyAdded : t.stickyBtn;
    if (!tot) return;
    var parts = this.summaryParts(), bundle = s.sel !== 'single';
    this.set('[data-sticky-label]', bar, 'textContent', this.q('[data-sticky-label2]', bar) ? parts[0] : this.summaryText());
    this.set('[data-sticky-label2]', bar, 'textContent', parts[1]);
    this.set('[data-sticky-perks]', bar, 'hidden', !bundle);
    if (bundle) {
      this.set('[data-sticky-save]', bar, 'textContent', fill(t.saveLine, { save: this.money(tot.strike - tot.total), worth: this.money(tot.worth), n: tot.freeCount }));
      var sg = this.set('[data-sticky-gift]', bar, 'textContent', fill(t.saveGift, { n: tot.freeCount }));
      if (sg) sg.hidden = !tot.freeCount;
    }
    this.q('[data-sticky-total]', bar).textContent = this.money(tot.total);
    var st = this.q('[data-sticky-strike]', bar);
    st.hidden = s.sel === 'single';
    st.textContent = this.money(tot.strike);
  };

  /* ---------- validation + cart ---------- */
  P.addToCart = function () {
    var s = this.S, self = this;
    if (s.busy) return;
    if (!s.sel) { this.kickAll(120); this.shake(this.q('[data-guide]')); return; }
    var card = this.cards[s.sel];
    var need = this.freeN(), have = s.picks[s.sel].length;
    var noTime = !s.time, noStk = have < need, miss = this.missingChoice(card);
    if (miss || noTime || noStk) {
      s.err = noStk; s.errTime = noTime; s.errChoice = !!miss;
      this.render();
      var timeBox = this.q('[data-time-box]', card), stkBox = this.q('[data-stk-box]', card);
      var first = miss || (noTime ? timeBox : stkBox); // choices, then making time, then stickers
      setTimeout(function () { self.scrollToCenter(first); self.shake(first); }, 30);
      return;
    }

    var items = this.buildItems();

    var drawer = this.cfg.cartType === 'drawer' ? document.querySelector('cart-drawer') : null;
    var body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
      body.sections_url = window.location.pathname;
    }

    s.busy = true; s.failed = false; s.err = false; s.errTime = false; s.errChoice = false;
    this.render();
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Add to cart failed'); return j; });
    }).then(function (res) {
      s.busy = false; s.added = true;
      self.render();
      if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
        setTimeout(function () { s.added = false; self.render(); }, 1600);
      } else {
        setTimeout(function () { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; }, 800);
      }
    }).catch(function (e) {
      if (window.console) console.error('[set customizer]', e);
      s.busy = false; s.failed = true;
      self.render();
      setTimeout(function () { s.failed = false; self.render(); }, 2500);
    });
  };

  P.buildItems = function () {
    var s = this.S, main = this.mainVariant(), t = this.cfg.t, stk = this.cfg.stickers, N = this.freeN();
    var props = this.mainProps();
    props[t.propTime] = s.time === 'rush' ? t.propRush : t.propStd;
    if (s.sel !== 'single' && N > 0) {
      props[t.propFree] = s.picks[s.sel].slice(0, N).map(function (i) { return stk[i].prop || stk[i].name; }).join(', ');
    }
    var items = [{ id: main.id, quantity: s.qty, properties: props }].concat(this.addOnItems());
    var pv = this.prioVariant();
    if (pv) items.push({ id: pv.id, quantity: s.qty });
    // Spider-Verse: free picks go in as real sticker lines (one per set); the store's automatic
    // Buy X Get Y discounts make N stickers free per bundle. A skin can set freeAsLines: false
    // to keep free picks in the property only. Extras stay quantity 1.
    if (this.cfg.freeAsLines !== false) {
      s.picks[s.sel].slice(0, N).forEach(function (i) { items.push({ id: stk[i].id, quantity: s.qty }); });
    }
    this.extras().forEach(function (i) { items.push({ id: stk[i].id, quantity: 1 }); });
    return items;
  };

  P.headerOffset = function () {
    var h = document.querySelector('sticky-header, .section-header');
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 && r.top <= 0 + 1 ? r.bottom : 0;
  };
  P.scrollToCenter = function (el) {
    if (!el) return;
    var hdr = this.headerOffset(), r = el.getBoundingClientRect();
    var avail = window.innerHeight - hdr;
    var y = window.pageYOffset + r.top - hdr - Math.max(12, (avail - r.height) / 2);
    window.scrollTo({ top: Math.max(0, y), behavior: this.reduce ? 'auto' : 'smooth' });
  };
  P.shake = function (el) {
    if (!el || this.reduce) return;
    el.classList.remove('is-shake'); void el.offsetWidth; el.classList.add('is-shake');
    setTimeout(function () { el.classList.remove('is-shake'); }, 500);
  };

  /* ---------- motion ---------- */
  P.B = function (id) {
    if (!this.bodies[id]) this.bodies[id] = { a: 0, v: 0, ph: Math.random() * 6.28, drag: false, el: this.q('[data-hang="' + id + '"]'), sense: 0, sc: 1 };
    return this.bodies[id];
  };
  P.startLoop = function () {
    if (this.raf) return;
    var self = this, last = performance.now();
    this.qa('[data-hang]').forEach(function (el) { self.B(el.dataset.hang); });
    var loop = function (now) {
      var dt = Math.min(0.033, Math.max(0.001, (now - last) / 1000)); last = now;
      self.step(dt, now / 1000);
      self.raf = requestAnimationFrame(loop);
    };
    this.raf = requestAnimationFrame(loop);
  };
  P.stopLoop = function () { if (this.raf) cancelAnimationFrame(this.raf); this.raf = 0; };
  P.step = function (dt, t) {
    var bs = this.bodies;
    for (var id in bs) {
      var b = bs[id];
      if (!b.drag) {
        var p = this.bodyParams(b);
        var target = this.reduce ? 0 : Math.sin(t * p.freq + b.ph) * p.amp;
        b.v += (-p.k * (b.a - target) - p.c * b.v) * dt; b.a += b.v * dt;
        if (b.a > 75) { b.a = 75; b.v *= -0.4; }
        if (b.a < -75) { b.a = -75; b.v *= -0.4; }
      }
      if (b.el) b.el.style.transform = 'rotate(' + (b.a * b.sc).toFixed(2) + 'deg)';
    }
    this.stepFx(dt);
  };
  P.hit = function (l, r, gap, fx) {
    var m = this.bodies[l], g = this.bodies[r];
    if (!m || !g) return;
    if (g.a - m.a > gap && g.v - m.v > 0) {
      var mv = m.v, gv = g.v; m.v = gv * 0.85; g.v = mv * 0.85;
      var mid = (g.a + m.a) / 2; m.a = mid - gap / 2; g.a = mid + gap / 2;
      if (Math.abs(mv - gv) > 25) fx();
    }
  };
  P.glitchAll = function () {
    var now = performance.now();
    if (this.lastGlitch && now - this.lastGlitch < 700) return;
    this.lastGlitch = now;
    this.glitch('trio-0'); this.glitch('trio-1'); this.glitch('trio-2');
  };
  P.pop = function (sel, to, key) {
    var now = performance.now();
    if (this.lastPop[key] && now - this.lastPop[key] < 500) return;
    this.lastPop[key] = now;
    var el = this.q(sel); if (!el) return;
    el.style.transition = 'none'; el.style.opacity = '1'; el.style.transform = 'translate(-50%, 0) scale(0.6)';
    void el.offsetWidth;
    el.style.transition = 'opacity 1s ease-out, transform 1s cubic-bezier(.2,.8,.2,1)';
    el.style.opacity = '0'; el.style.transform = to;
  };
  P.bubble = function (row, text) {
    var el = this.q('[data-bubble="' + row + '"]');
    if (!el || !text) return;
    var reduce = this.reduce;
    el.textContent = text;
    el.style.transition = 'none'; el.style.opacity = '0';
    el.style.transform = reduce ? 'rotate(-3deg)' : 'scale(0.4) rotate(-6deg)';
    void el.offsetWidth;
    el.style.transition = reduce ? 'none' : 'opacity .25s, transform .35s cubic-bezier(.3,1.6,.5,1)';
    el.style.opacity = '1'; el.style.transform = 'scale(1) rotate(-3deg)';
    clearTimeout(this.bubbleT);
    this.bubbleT = setTimeout(function () { el.style.transition = reduce ? 'none' : 'opacity .5s'; el.style.opacity = '0'; }, 1900);
  };
  P.swapImg = function (hid, hero) {
    var img = this.q('[data-img="' + hid + '"]');
    if (!img) return;
    img.src = this.cfg.img[hero];
    img.alt = this.cfg.names[hero] + ' ' + (img.dataset.altSuffix || '');
  };
  P.glitch = function (id) {
    if (this.reduce) return;
    var el = this.q('[data-img="' + id + '"]');
    if (!el) return;
    el.classList.remove('is-glitch'); void el.offsetWidth; el.classList.add('is-glitch');
  };
  P.kick = function (ids, amt) {
    if (this.reduce) return;
    var self = this;
    ids.forEach(function (id, i) { var b = self.B(id); b.v += (i % 2 ? -1 : 1) * amt * self.kickMul(b) * (0.75 + Math.random() * 0.5); });
  };
  P.kickAll = function (amt) { this.kick(Object.keys(this.bodies), amt); };

  P.bindDrag = function (el, cardId) {
    var self = this, id = el.dataset.hang, st = {};
    el.addEventListener('pointerdown', function (e) {
      if (e.button && e.button !== 0) return;
      var b = self.B(id), piv = el.parentNode.getBoundingClientRect();
      st = { px: piv.left, py: piv.top, x0: e.clientX, y0: e.clientY, moved: false, lt: performance.now(), la: b.a, pid: e.pointerId };
      b.drag = true; b.v = 0;
    });
    el.addEventListener('pointermove', function (e) {
      var b = self.B(id); if (!b.drag || b.sc < 1) return;
      if (!st.moved && Math.abs(e.clientX - st.x0) + Math.abs(e.clientY - st.y0) > 6) {
        st.moved = true;
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (!st.moved) return;
      var ang = Math.atan2(-(e.clientX - st.px), Math.max(e.clientY - st.py, 10)) * 180 / Math.PI;
      ang = Math.max(-75, Math.min(75, ang));
      var now = performance.now(), d = Math.max(0.008, (now - st.lt) / 1000);
      b.v = (ang - st.la) / d * 0.6; st.la = ang; st.lt = now; b.a = ang;
    });
    var up = function (e) {
      var b = self.B(id); if (!b.drag) return; b.drag = false;
      if (!st.moved && e.type === 'pointerup') {
        b.v += (Math.random() < 0.5 ? -1 : 1) * 160 * (b.heavy ? 0.6 : 1);
        self.openSet(cardId); // a plushie tap never closes a card
      }
    };
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);
  };

  // Skins register a subclass here; a root whose skin script hasn't loaded yet waits for it.
  SetCustomizer.skins = {};
  function init(ctx) {
    (ctx || document).querySelectorAll('[data-svc]').forEach(function (root) {
      if (root.__svc) return;
      var skin = root.dataset.svcSkin, Ctor = skin ? SetCustomizer.skins[skin] : SetCustomizer;
      if (!Ctor) return;
      root.__svc = new Ctor(root);
    });
  }
  SetCustomizer.fill = fill;
  SetCustomizer.shuffle = shuffle;
  SetCustomizer.init = init;
  window.SVSetCustomizer = SetCustomizer;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-svc]');
    if (root && root.__svc) { root.__svc.stopLoop(); clearInterval(root.__svc.cycle); if (root.__svc.destroy) root.__svc.destroy(); }
  });
})();
